import React, { useReducer } from 'react'
import { TeamContext } from '@abroad/components'
import intentionReducer, { initialState } from './teamReducer'

const TeamProvider = ({ children }) => {
  const [state, dispatch] = useReducer(intentionReducer, initialState)
  return (
    <TeamContext.Provider value={{ state, dispatch }}>
      {children}
    </TeamContext.Provider>
  )
}

export default TeamProvider
